import { useDispatch } from "react-redux";
import { default as clientIdService } from "../services/clientId";
import { defineToken } from "../utils/token";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { ClientIDLoginParam } from "../types/clientId";
import { loginFailure, loginRequest, loginSuccess } from "../actions";
import useContractation from "@/components/Contractation/hooks/useContractation";
import { useTranslation } from "react-i18next";
import cookiesUtils from "@/utils/cookies";
import useI18n from "@/hooks/useI18n";

const useClientId = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { firstContractationPath } = useContractation();
  const { t } = useTranslation();
  const { changeLang } = useI18n();

  const loginClientId = ({clientId, secret}: ClientIDLoginParam) => {
    cookiesUtils.acceptConsentCookies();
    dispatch(loginRequest('clientId'));
    clientIdService.login({clientId, secret})
    .then(({token}) => {
      if (token) {
        const { locale } = defineToken(token);
        changeLang(locale);
        dispatch(loginSuccess());
        firstContractationPath && navigate(t(firstContractationPath));
      } else {
        dispatch(loginFailure({statusCode: 505, statusType: "error"}));
      }
    })
    .catch((error: AxiosError) => {
      dispatch(loginFailure({statusCode: 505, statusType: "error"}));
    });
  };

  return {
    loginClientId
  }
};

export default useClientId;